import { isUnsplashItem } from './media-manager-sdk/items';
import { cond, T, propOr, pipe } from 'ramda';

export const makeCreatorLink = cond([
  [isUnsplashItem, pipe(propOr('#', 'creatorUrl'), (url) => `${url}?utm_source=wix-media-manager&utm_medium=referral`)],
  [T, propOr('#', 'creatorUrl')],
]);
